import {API_BASE} from '../apiConfig';

// Архивы записей: сетевые матчи и прохождения обучения (см.
// server/utils/replays/replaysArchive.js, REPLAYS_ARCHIVE_KINDS)
export const REPLAYS_ARCHIVE_KINDS = Object.freeze({
  NETWORK: 'network',
  TUTORIAL: 'tutorial',
});

// Имя файла собирается на клиенте: Content-Disposition кросс-доменного ответа
// (дев: страница на :3000, API на :3001) без Access-Control-Expose-Headers
// прочитать нельзя
export const getReplaysArchiveFileName = (date = new Date(), kind = REPLAYS_ARCHIVE_KINDS.NETWORK) => (
  `strategikon-${kind === REPLAYS_ARCHIVE_KINDS.TUTORIAL ? 'tutorial-' : ''}replays-${date.toISOString().slice(0, 10)}.zip`
);

// Ссылку на blob отзываем не сразу: большой архив браузер может начать
// сохранять не мгновенно, а ранний revokeObjectURL оборвал бы скачивание
const OBJECT_URL_REVOKE_DELAY_MS = 60000;

/**
 * Скачивание архива записей (кнопки «Архив всех реплеев» и «Архив записей
 * обучения» в админке). Сервер собирает zip на лету, см.
 * server/utils/replays/replaysArchive.js. Возвращает размер архива в байтах;
 * при ошибке бросает исключение с текстом сервера.
 */
export const downloadReplaysArchive = async ({kind = REPLAYS_ARCHIVE_KINDS.NETWORK} = {}) => {
  const query = kind === REPLAYS_ARCHIVE_KINDS.TUTORIAL ? `?kind=${REPLAYS_ARCHIVE_KINDS.TUTORIAL}` : '';
  const response = await fetch(`${API_BASE}/admin/replays/archive${query}`, {credentials: 'include'});
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Не удалось собрать архив реплеев');
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = getReplaysArchiveFileName(new Date(), kind);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), OBJECT_URL_REVOKE_DELAY_MS);
  return blob.size;
};
